import _ from 'lodash';
import moment from 'moment';
import he from 'he';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { alertMsg } from '../apis/commlogic';
import { LOGIN_INFO, WARD_INFO, HYPER_LINK_REGEX } from '../comm/constant';
import { store } from '../redux';
import { hospitalWardListFunc } from './hospitalWardList';
import { classNames } from './objectString';
import { userRoleList } from './userRole';
import { getRandomNum } from './randomUtil';
import { mutationUpdateOtherLoginInfo } from './handleUpdateOtherLoginInfo';
import getFileType from './getFileType';

const getAuthToken = () => {
  let authToken = null;
  const logininfoStr = localStorage.getItem(LOGIN_INFO);
  if (logininfoStr) {
    try {
      const { token } = JSON.parse(logininfoStr);
      authToken = token;
    } catch (error) {}
  }
  return authToken;
};

const getInputWidth = function (text, fontSize) {
  const id = '_getInputWidth';
  const sensor = document.createElement('span');
  sensor.style.fontSize = fontSize;
  sensor.id = id;
  sensor.innerText = text;
  document.body.appendChild(sensor);
  const width = sensor.offsetWidth;
  sensor.remove();
  return width;
};

const downloadFileById = async (requestPromit, fileNameCall, type = 'application/vnd.ms-excel') => {
  const excelId = 'export_excel';
  const link = document.createElement('a');
  link.style.display = 'none';
  link.id = excelId;
  document.body.appendChild(link);
  try {
    const res = await requestPromit();
    const { data: resData } = res;
    if (resData?.type === 'application/json') {
      let reader = new FileReader();
      reader.readAsText(resData, 'utf-8');
      reader.onload = () => {
        try {
          const { statusMessage } = JSON.parse(reader.result);
          alertMsg(statusMessage, _.uniqueId('error_'));
        } catch {
          alertMsg('error', _.uniqueId('error_'));
        }
      };
    } else {
      let blob;
      if (resData?.type?.indexOf('image') >= 0) {
        blob = resData;
      } else {
        blob = new Blob([resData], {
          type,
        });
      }
      const newLink = document.getElementById(excelId);
      const blobUrl = URL.createObjectURL(blob);
      newLink.href = blobUrl;
      newLink.setAttribute('download', fileNameCall(resData));
      if (/iPad/.test(navigator.userAgent) && /CriOS/.test(navigator.userAgent)) {
        window.open(blobUrl);
      } else {
        newLink.click();
      }
      URL.revokeObjectURL(blobUrl);
    }
    document.body.removeChild(document.getElementById(excelId));
  } catch (error) {
    document.body.removeChild(document.getElementById(excelId));
  }
};

const updateWpLoginLocalStorage = (wardName, wardId, hospitalId, hospitalName, userId) => {
  try {
    const loginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));
    loginInfo.wardName = wardName;
    loginInfo.wardId = wardId;
    loginInfo.hospitalId = hospitalId;
    loginInfo.hospitalName = hospitalName;
    loginInfo.userId = userId;
    localStorage.setItem(LOGIN_INFO, JSON.stringify(loginInfo));
    mutationUpdateOtherLoginInfo();
  } catch {}
};

const getXIds = () => {
  try {
    const loginLocal = localStorage.getItem(LOGIN_INFO);
    const wardLocal = localStorage.getItem(WARD_INFO);
    const loginInfo = loginLocal && JSON.parse(loginLocal);
    const wardInfo = wardLocal && JSON.parse(wardLocal);
    if (loginInfo?.wardId !== undefined) {
      return { hospitalId: loginInfo.hospitalId, wardId: loginInfo.wardId, userId: loginInfo?.userId ?? null };
    } else if (loginInfo?.hospitalId !== undefined) {
      return { hospitalId: loginInfo.hospitalId, wardId: loginInfo.wardId ?? null, userId: loginInfo?.userId ?? null };
    }
    return { hospitalId: wardInfo.hospitalId, wardId: wardInfo.wardId, userId: loginInfo?.userId ?? null };
  } catch (e) {
    return {};
  }
};

const getWardName = () => {
  try {
    const loginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));
    const wardInfo = JSON.parse(localStorage.getItem(WARD_INFO));
    if (loginInfo?.wardName === '' || loginInfo?.wardName) {
      return loginInfo.wardName;
    }
    return wardInfo.wardName;
  } catch {
    return '';
  }
};

const getWardId = () => {
  return getUserInfo().wardId;
};

const getHospitalId = () => {
  return getUserInfo().hospId;
};

const isRequest = (loginInfo, userRole) => {
  return !loginInfo?.flag || Array.isArray(userRole);
};

const getUserInfo = () => {
  let result = null;
  const state = store.getState();
  if (state) {
    const { userRole, hospitalWardList, loginInfo, wardInfo } = state;

    if (loginInfo?.flag) {
      result = userRoleList.getDetailFormat(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);

      if(userRole === null || userRole === undefined){
        let result2 = hospitalWardListFunc.getDetailFormat(
          hospitalWardList,
          wardInfo.hospitalId,
          wardInfo.wardId,
          wardInfo.hospCode
        );
  
        result.hospId = result?.hospId ?? result2?.hospId ?? null;
        result.wardId = result?.wardId ?? result2?.wardId ?? null;
      }

    } else {
      result = hospitalWardListFunc.getDetailFormat(
        hospitalWardList,
        wardInfo.hospitalId,
        wardInfo.wardId,
        wardInfo.hospCode
      );
    }
    result.flag = loginInfo?.flag;
  }
  return result;
};

const useGetUserInfo = (callBack) => {
  let result = null;
  const { userRole, hospitalWardList, loginInfo, wardInfo } = useSelector((state) => state);
  if (loginInfo?.flag) {
    result = userRoleList.getDetailFormat(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);
  } else {
    result = hospitalWardListFunc.getDetailFormat(hospitalWardList, wardInfo.hospitalId, wardInfo.wardId);
  }
  result.flag = loginInfo?.flag;
  return callBack ? callBack(result) : result;
};

let CorrelationId = moment().format('yyyyMMDDHHmmssSSS') + getRandomNum();

const getEhandoverHeaderParams = (url, EHANDOVER_API_HOST) => {
  const XIds = getUserInfo();
  const state = store.getState();
  const { wardInfo, loginInfo, userRole } = state;
  let functionId = null;
  let functions = _.find(
    userRole,
    (item) => loginInfo.hospitalId === item.hospId && loginInfo.userId === item.userId
  )?.funcs;

  if (!loginInfo.flag) {
    CorrelationId = moment().format('yyyyMMDDHHmmssSSS') + getRandomNum();
  }

  if (functions) {
    functionId = _.find(functions, (item) =>
      item.apiPath ? item.apiPath.split(',').some((functionItem) => url.includes(functionItem)) : null
    );
  }

  const handleListFunctionName = () => {
    return `${url
      .slice(url.indexOf(EHANDOVER_API_HOST) + EHANDOVER_API_HOST.length + 1)
      .split('/')
      .join(' ')} view`;
  };

  let wardCode = wardInfo.wardName;
  if (/[\u4e00-\u9fa5]/.test(wardCode ?? '')) {
    wardCode = encodeURIComponent(wardCode);
  }

  const ehandoverParams = {
    'x-Ward-Code': wardCode,
    'x-Hosp-Code': loginInfo.hospitalName,
    'x-CorpId': XIds.corpId,
    'x-Function-Id': functionId?.funtionName ?? handleListFunctionName(),
    'x-Correlation-Id': loginInfo.flag ? CorrelationId : moment().format('yyyyMMDDHHmmssSSS') + getRandomNum(),
    'x-Transaction-Id': moment().format('yyyyMMDDHHmmssSSS') + getRandomNum(),
  };

  return ehandoverParams;
};

const initValue = (value, placeholder = '') => value ?? placeholder;

const getUUID = () => uuidv4();

const conditional = (condition, exprIfTrue, exprIfFalse) => (condition ? exprIfTrue : exprIfFalse);

const onKeyUpEnterOrSpace = (e, callback) => {
  if ((e.keyCode === 13 || e.keyCode === 32) && _.isFunction(callback)) {
    callback();
  }
};

const getArrayRandomKey = (index = '', prefix = 'key') => {
  return `${prefix}-${index}`;
};

const revokePreviewUrl = (previewList) => {
  previewList.forEach((item) => {
    if (!item?.previewUrl) return;
    URL.revokeObjectURL(item?.previewUrl);
  });
};

const escapeHtmlKeepUrls = (text) => {
  // First, identify and protect URLs (replace them with temporary placeholders)
  const urlPlaceholders = [];
  const withProtectedUrls = String(text).replace(HYPER_LINK_REGEX, (match) => {
    const placeholder = `~~~URL_PLACEHOLDER_${urlPlaceholders.length}~~~`;
    urlPlaceholders.push(match);
    return placeholder;
  });

  const escaped = he.escape(withProtectedUrls);

  // Restore URLs and convert them to links
  return escaped.replace(/~~~URL_PLACEHOLDER_(\d+)~~~/g, (_, index) => {
    const match = urlPlaceholders[Number(index)];
    const haveHttp = match.startsWith('http');
    const href = haveHttp ? match : `http://${match}`;
    return `<a href="${href}" target="_blank" rel="noreferrer">${match}</a>`;
  });
};

const getRealBash64Str = (base64 = '') => {
  if (base64) {
    const dotIdx = base64.indexOf(',');
    return dotIdx > -1 ? base64.substring(dotIdx + 1, dotIdx + 1 + base64.length) : null;
  } else {
    return null;
  }
};

const isImageFile = (fileName) => getFileType(fileName) === 'picture';

const isNotEmpty = (value) => {
  if (!_.isString(value) && !_.isArray(value)) {
    return false;
  }
  return !_.isEmpty(value);
};

export {
  classNames,
  getAuthToken,
  downloadFileById,
  updateWpLoginLocalStorage,
  getXIds,
  getWardName,
  getInputWidth,
  getWardId,
  getHospitalId,
  isRequest,
  getUserInfo,
  useGetUserInfo,
  getEhandoverHeaderParams,
  initValue,
  getUUID,
  conditional,
  onKeyUpEnterOrSpace,
  getArrayRandomKey,
  revokePreviewUrl,
  escapeHtmlKeepUrls,
  getRealBash64Str,
  isImageFile,
  isNotEmpty,
};
